import i18n from "i18next";
import type { FC } from "react";

import { FormComponent, type FormFieldFactoryProps, type FormFieldWrapperProps } from "../../types/types";
import { FormFieldInputStyle, FormFieldLabelStyle, VerticalFormFieldStyle } from "../styles/FormFieldsStyle";
import { withLabelColon } from "../withLabelColon";

interface VerticalFormFieldWrapperProps {
    field?: FormFieldFactoryProps;
    formComponent: React.JSX.Element;
}

export const VerticalFormFieldWrapper: FC<VerticalFormFieldWrapperProps> = ({ field, formComponent }: FormFieldWrapperProps) => {
    // Check if the field is a UsersTable and if the identity service is Entra or IDM. Remove the wrong table label from the form;
    if (
        // eslint-disable-next-line no-underscore-dangle
        (field?.component === FormComponent.DATA_GROUP_IDM_USERS_TABLE && window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra") ||
        // eslint-disable-next-line no-underscore-dangle
        (field?.component === FormComponent.DATA_GROUP_USERS_TABLE && window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "idm")
    ) {
        return null;
    }

    // TerminalHostTerminalTableField label placement is rendered dynamically depending on content
    if (field?.component === FormComponent.TERMINAL_HOST_TERMINAL) {
        return formComponent;
    }

    return (
        (field?.translationKeys && (
            <VerticalFormFieldStyle>
                <FormFieldLabelStyle>{withLabelColon(i18n.t(field.translationKeys.label))}</FormFieldLabelStyle>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </VerticalFormFieldStyle>
        )) ||
        null
    );
};
